module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "pla"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("MAJOR PLAYERS")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("YEAR 2029, HUMAN RESISTANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("John Connor, leader")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Kate Brewster, leader")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Michaela “Mike” Herrera, scientific adviser")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Daniel Ávila, programming adviser")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Dr. Tamara Lake, medical adviser")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Resistance 1st Security Regiment:")]), _vm._v(" "), _c('p', {
    staticClass: "nsl"
  }, [_vm._v("Colonel Sidney Walker, commander")]), _vm._v(" "), _c('p', {
    staticClass: "nsl"
  }, [_vm._v("Lieutenant David “Ten” Zimmerman, squadron leader, Hell-Hounds (Company A, Squadron 3)")]), _vm._v(" "), _c('p', {
    staticClass: "nsl"
  }, [_vm._v("Earl Duncan, Hell-Hounds")]), _vm._v(" "), _c('p', {
    staticClass: "nsl"
  }, [_vm._v("Mark Herrera, Hell-Hounds")]), _vm._v(" "), _c('p', {
    staticClass: "nsl"
  }, [_vm._v("Kyla Connor, Hell-Hounds")]), _vm._v(" "), _c('p', {
    staticClass: "nsl"
  }, [_vm._v("Ripper, Hell-Hounds")]), _vm._v(" "), _c('p', {
    staticClass: "nsl"
  }, [_vm._v("Ginger, Hell-Hounds")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PRESENT DAY")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Danny Ávila, programmer, Cyber Research Systems (CRS)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Linda Ávila, deputy, Kern County Sheriff’s Department")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Teresa “Mama” Ávila")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Lieutenant General Robert Brewster, head of operations, CRS")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Dr. Philip Sherman, lead programmer, CRS")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("Jerry Squires, programmer, CRS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237263f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/play.vue
// module id = 75
// module chunks = 0